import React, { Fragment, useState } from "react";
import { makeStyles } from "@mui/styles";
import Typo from "../../common/Typo";
import IconCard from "../../common/TextCard";
import { useDispatch } from "react-redux";
import { setQulificationStore } from "../../../redux/reducers/getData";
import Footer from "../../common/Footer";
import { dataOfAverageCustomerCome, dataOfAverageCustomerSpend } from "../../../data/plan-data";

const useStyles = makeStyles((theme) => ({
  animation: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '10px',
    maxHeight: '78vh',
    width: '100vw',
    overflowY: 'scroll',
    animation: `$lauchTime 600ms ${theme.transitions.easing.easeInOut}`
  },
  sectiontwo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    animation: `$lauchTime 600ms ${theme.transitions.easing.easeInOut}`
  },
  "@keyframes lauchTime": {
    "0%": {
      transform: "translateX(200%)",
    },
    "100%": {
      transform: "translateX(0)",
    }
  },
  subText: {
    width: '100%',
    textAlign: 'center',
    marginTop: '20px'
  },
  infocard: {
    display: 'flex',
    maxWidth: '100%',
    margin: "3.5% 0",
    columnGap: '20px',
    justifyContent: "center",
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  "@media (max-width: 1000px)": {
    animation: {
      padding: '0 20px',
      margin: '0',
    },
    infocard: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '20px'
    }
  },
}));

function StepThree({ setStepTwo, setStepThree, setStepFour, onButtonClick }) {
  const classes = useStyles();
  const dispatch = useDispatch()

  const [selectedCustomer, setSelectedCustomer] = useState(false)
  const [selectedTicket, setSelectedTicket] = useState(false)

  const [customer, setCustomer] = useState()
  const [ticketPrice, setTicketPrice] = useState()

  const [sectionTwo, setSectionTwo] = useState(false)
  const [isDisable, setisDisable] = useState(false)

  let index = customer?.indexOf("-")
  let customerscountstart = customer?.substr(0, index)
  let customerscountend = customer?.substr(index + 1)

  let indexTicket = ticketPrice?.indexOf("-")
  let average_bill_start = ticketPrice?.substr(0, indexTicket)
  let average_bill_end = ticketPrice?.substr(indexTicket + 1)

  let passData = {
    average_customers_count_start: customerscountstart,
    average_customers_count_end: customerscountstart === "150" ? null : customerscountend,
    average_bill_start: average_bill_start,
    average_bill_end: average_bill_start === "25" ? null : average_bill_end,
  }

  //02 state store in contex & next step open
  function stateStore() {
    dispatch(setQulificationStore({ passData }))
    setStepTwo(false)
    setStepThree(false)
    setStepFour(true)
    onButtonClick("pagefour")
  }
  //

  const handleCustomerCount = (value) => {
    setSelectedTicket(value)
    setSectionTwo(true)
    setCustomer(value)
  }
  const handleBillCount = (value) => {
    setSelectedCustomer(value)
    setTicketPrice(value)
    setisDisable(true)
  }

  const getValueFunction = () => {
    setStepThree(false)
    setStepFour(true)
    onButtonClick("pagefour")
    stateStore()
  }

  const handleBackPage = () => {
    setStepThree(false)
    setStepTwo(true)
  }
  return (
    <>
      <div className={classes.animation}>
        <div className={classes.form} >

          {/* customer count design  */}
          <Typo className={classes.subText} variant='pp01B'>How many customers on average come into your store a day?</Typo>
          <div className={classes.infocard}>
            {dataOfAverageCustomerCome?.map((item, index) => {
              return (
                <Fragment key={index}>
                  <IconCard
                    text={item?.showvalue}
                    onClick={() => handleCustomerCount(item?.passvalue)}
                    selectedDiv={selectedTicket === item?.passvalue ? true : false}
                  />
                </Fragment>
              )
            })}
          </div>

          {sectionTwo &&
            <div className={classes.sectiontwo}>

              {/* bill count design  */}
              <Typo className={classes.subText} variant='pp01B'>How much does the average customer spend in your store?</Typo>
              <div className={classes.infocard}>
                {dataOfAverageCustomerSpend?.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <IconCard
                        text={`$${item?.showvalue}`}
                        onClick={() => handleBillCount(item?.passvalue)}
                        selectedDiv={selectedCustomer === item?.passvalue ? true : false}
                      />
                    </Fragment>
                  )
                })}
              </div>
            </div>
          }

        </div>
      </div>
      {/*<ChatIcon />*/}
      <Footer
        buttonText="Next"
        onSubmit={getValueFunction}
        handleBackPage={handleBackPage}
        isDisable={isDisable}
      />
    </>
  );
}

export default StepThree;
